import { createSlice } from "@reduxjs/toolkit";

const collectionNameSlice = createSlice({
    name: "collectionName",
    initialState: {
        collectionName: null,
    },
    reducers: {
        setCollectionName: (state, action) => {
            state.selectProductId = action.payload;
        },
    },
});

export const { setCollectionName } = collectionNameSlice.actions;
export default collectionNameSlice.reducer;
